var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 400",
    width: 650,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m331.7 294.2c-163.4 0-297.7 170.8-302.7-3.6-7.1-258.6 139.3-261.6 302.7-261.6 163.4 0 293.5-13.1 288.5 261.6-3.4 180.1-125.1 3.6-288.5 3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerBack);
export default __webpack_public_path__ + "static/media/lower_back.82a905d31f15edb536f9baa5273c3045.svg";
export { ForwardRef as ReactComponent };